import { useCallback } from 'react';
import { createId } from '@paralleldrive/cuid2';
import type { ChatAction } from '@trinity/chat';
import {
  SubmitActionContext,
} from './context';
import { useSelectedQueryParentIdentifier } from './hooks/useSelectedQueryParentIdentifier';
import { useSubmitQueryMutation } from './hooks/useSubmitQueryMutation';

type Props = {
  children: React.ReactNode;
};

export const SubmitChatActionContainer = (props: Props) => {

  const mutation = useSubmitQueryMutation();
  const getSelectedQueryParentIdentifier = useSelectedQueryParentIdentifier();

  const handleSubmit = useCallback((action: ChatAction, query: string) => {
    const identifier = createId();
    const parentQueryIdentifier = getSelectedQueryParentIdentifier();

    return mutation.mutateAsync({
      action,
      identifier,
      parentQueryIdentifier,
      query,
    });
  }, [getSelectedQueryParentIdentifier, mutation]);

  return (
    <SubmitActionContext.Provider value={handleSubmit}>
      {props.children}
    </SubmitActionContext.Provider>
  );
};